type Season = 'halloween' | 'thanksgiving' | 'winter' | 'valentine' | null;

const getSeason = (): Season => {
  // You can mock the date here for testing, e.g., new Date('2026-11-26')
  const today = new Date();
  const month = today.getMonth(); // 0-indexed (0 = Jan, 11 = Dec)
  const date = today.getDate();

  // Valentine's Day (Feb 7 - Feb 15)
  if (month === 1 && date >= 7 && date <= 15) {
    return 'valentine';
  }

  // Halloween (Oct 24 - Nov 1)
  if ((month === 9 && date >= 24) || (month === 10 && date === 1)) {
    return 'halloween';
  }

  // Thanksgiving (Approximate range in late Nov: Nov 20 - Nov 30)
  if (month === 10 && date >= 20 && date <= 30) {
    return 'thanksgiving';
  }

  // Winter Holidays (Dec 15 - Dec 31)
  if (month === 11 && date >= 15) {
    return 'winter';
  }

  return null;
};

export function useSeasonalTheme(): Season {
  // The season derives purely from today's date; computing it at module level keeps
  // the impure `new Date()` out of render scope (no effect / setState needed).
  return getSeason();
}